import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Menu.png'
import _imports_1 from '@/assets/footer.png'
import _imports_2 from '@/assets/Facebook.png'
import _imports_3 from '@/assets/Instagram.png'
import _imports_4 from '@/assets/Whatsapp.png'


const _hoisted_1 = { class: "container-fluid px-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "navcustom d-md-flex d-none py-0" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "social" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<ul><li><a href=\"#\"><img class=\"logomenu\" src=\"" + _imports_1 + "\"></a></li><li><a href=\"https://www.facebook.com/CentraldeApoioCACCC/\" target=\"_blank\"><img src=\"" + _imports_2 + "\"></a></li><li><a href=\"https://www.instagram.com/centraldeapoiocaccc/?igshid=YmMyMTA2M2Y=\" target=\"_blank\"><img src=\"" + _imports_3 + "\"></a></li><li><a href=\"https://bit.ly/3LZCIqm\" target=\"_blank\"><img src=\"" + _imports_4 + "\"></a></li></ul>", 1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { class: "querodoar" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://alegriadeviver.colabore.org/CACCC/",
      target: "blank"
    }, "Quero Doar")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"footer\"><div class=\"container\"><div class=\"d-flex d-md-flex itens\"><ul><li><a href=\"/historia\">Nossa história</a></li><li><a href=\"/como-doar\">Como doar</a></li><li><a href=\"/instituicao\">ONGs Assistidas</a></li></ul><ul><li><a href=\"#\"><img class=\"logo\" src=\"" + _imports_1 + "\"></a></li></ul><ul class=\"v-center\"><li><a class=\"px-2\" href=\"https://www.facebook.com/CentraldeApoioCACCC/\" target=\"_blank\"><img class=\"socialimg\" src=\"" + _imports_2 + "\"></a><a href=\"https://www.instagram.com/centraldeapoiocaccc/?igshid=YmMyMTA2M2Y=\" target=\"_blank\"><img class=\"socialimg\" src=\"" + _imports_3 + "\"></a><a class=\"px-2\" href=\"https://bit.ly/3LZCIqm\" target=\"_blank\"><img class=\"socialimg\" src=\"" + _imports_4 + "\"></a></li><li class=\"text d-md-none\">Central de Apoio às Casas<br>de Crianças com Câncer<br>CNPJ: 22.476.607/0001-85 </li><li class=\"text d-none d-md-block\">Central de Apoio às Casas<br>de Crianças com Câncer<br>CNPJ: 22.476.607/0001-85<br>Central do Voluntariado<br>Bairro: Centro - CEP: 01035-000 - Bairro: Centro - São Paulo - SP<br>Contato (11) 3224-2990<br>Avenida São João, 313 3o Andar - São Paulo/SP </li></ul></div><div class=\"d-flex d-md-none col-12 mt-3\"><div class=\"row\"><p class=\"mb-0\">Contato (11) 3224-2990</p><p class=\"mb-3\">Whatsapp (11) 96858-2990</p><p class=\"mb-0\">Central do Voluntariado</p><p class=\"mb-0\">Avenida São João, 313 3o Andar - São Paulo/SP </p></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-md-none d-flex", _ctx.classHome])
    }, [
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.show=!_ctx.show), ["prevent"]))
      }, _hoisted_3)
    ], 2),
    _createElementVNode("ul", {
      id: "menuNav",
      class: _normalizeClass(_ctx.showHome)
    }, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: "/",
          class: _normalizeClass((_ctx.pathUrl === '/') ? 'router-link-exact-active': '')
        }, "Home", 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: "/historia",
          class: _normalizeClass((_ctx.pathUrl === '/historia') ? 'router-link-exact-active': '')
        }, "Nossa história", 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: "/como-doar",
          class: _normalizeClass((_ctx.pathUrl === '/como-doar') ? 'router-link-exact-active': '')
        }, "Como doar", 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: "/instituicao",
          class: _normalizeClass((_ctx.pathUrl === '/instituicao') ? 'router-link-exact-active': '')
        }, "ONGs Assistidas", 2)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "/",
                class: _normalizeClass((_ctx.pathUrl === '/') ? 'router-link-exact-active': '')
              }, "Home", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "/historia",
                class: _normalizeClass((_ctx.pathUrl === '/historia') ? 'router-link-exact-active': '')
              }, "Nossa história", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "/como-doar",
                class: _normalizeClass((_ctx.pathUrl === '/como-doar') ? 'router-link-exact-active': '')
              }, "Como doar", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "/instituicao",
                class: _normalizeClass((_ctx.pathUrl === '/instituicao') ? 'router-link-exact-active': '')
              }, "ONGs Assistidas", 2)
            ])
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _hoisted_9
  ]))
}